import { combineReducers } from 'redux';
import { fetchContracts } from '../sagas/contracts/actions';
import { postContract } from '../sagas/settings/actions';
import { logoutButtonClick } from '../components/Auth/actions';

const contracts = (state = [], action) => {
  if (action.type === fetchContracts.done.type) {
    return action.payload.result.data;
  }

  if (action.type === postContract.done.type) {
    return [action.payload.result];
  }

  if (action.type === logoutButtonClick.type) {
    return [];
  }

  return state;
};

export default combineReducers({
  contracts,
});



// WEBPACK FOOTER //
// ./src/reducers/contracts.js